import React, { useMemo, useState } from "react";

import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Autocomplete, Button, Popover, Stack, TextField, TextFieldProps } from "@mui/material";
import {
  //  useActionHook,
  useDealParamsHooks
} from "hooks";
import {
  useRolesSelector
  //  useUserManageActions
} from "store";
import { IRole } from "store/types";
import {
  //  IUserManageGroup,
  IUsersManageQueries
} from "store/types/user-management";

import "./Filters.styles.scss";

const commonInputPtops: {
  sx?: TextFieldProps["sx"];
  size: TextFieldProps["size"];
  InputLabelProps: TextFieldProps["InputLabelProps"];
} = {
  size: "small",
  InputLabelProps: { shrink: true }
};
interface IFiltersProps {
  updateQueries: (data: Partial<IUsersManageQueries>) => void;
  isFiltersApplied: boolean;
}

export const Filters: React.FC<IFiltersProps> = ({ updateQueries, ...rest }) => {
  const [queries, setQueries] = useState<IUsersManageQueries>({});
  const { dealId } = useDealParamsHooks();
  // const { getGroupsAction } = useUserManageActions();
  const roles = useRolesSelector();

  // const { data: groups = [], action: getGroups } = useActionHook(getGroupsAction);

  // useEffect(() => {
  //   getGroups();
  // }, []);

  const allRoles = [
    ...roles,
    { id: -1, presentation_name: "Contact", name: "Contact", short_name: "Contact" } as unknown as IRole
  ];

  const selectedRoles = allRoles.filter((role) => {
    return queries.role_id?.find((roleId) => roleId === role.id);
  });

  // const selectedGroups = groups.filter((group) => {
  //   return queries.group_id?.find((groupId) => groupId === group.id);
  // });

  const isFiltersSelected: boolean = useMemo(() => {
    return !!Object.values({ ...rest }).filter(Boolean).length;
  }, [rest, dealId]);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <div className="filters">
      <Button
        sx={{ backgroundColor: isFiltersSelected ? "#dae0e2" : "transparent" }}
        onClick={handleClick}
        variant="outlined"
        size="sm"
        startIcon={<FilterAltIcon />}
      >
        Filters
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        sx={{ overflow: "hidden" }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <div className="users-filters-popup">
          <Autocomplete
            options={allRoles}
            multiple
            value={selectedRoles}
            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: IRole) => (
              <li {...props} key={option.id}>
                {option.presentation_name}
              </li>
            )}
            onChange={(_, option) => setQueries({ role_id: [...option].map((val) => val.id) })}
            getOptionLabel={(option) => option.presentation_name}
            renderInput={(params) => (
              <TextField
                {...params}
                {...commonInputPtops}
                label="Platform Role"
                placeholder={selectedRoles.length ? "" : "Select"}
              />
            )}
          />
          {/* {!!groups.length && (
            <Autocomplete
              options={groups}
              multiple
              value={selectedGroups}
              renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: IUserManageGroup) => (
                <li {...props} key={option.id}>
                  {option.name}
                </li>
              )}
              onChange={(_, option) => setQueries({ group_id: [...option].map((val) => val.id) })}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  {...commonInputPtops}
                  label="Group"
                  placeholder={selectedGroups.length ? "" : "Select"}
                />
              )}
            />
          )} */}
          <Stack flexDirection="row" justifyContent="flex-end" alignItems="center" gap="10px">
            <Button size="sm" variant="outlined" sx={{ minWidth: "53px" }} onClick={handleClose}>
              Cancel
            </Button>
            <Button
              onClick={() => {
                updateQueries({ role_id: queries.role_id, group_id: queries.group_id });
                handleClose();
              }}
              size="sm"
              variant="contained"
              sx={{ backgroundColor: "#071F35", minWidth: "46px" }}
            >
              Add
            </Button>
          </Stack>
        </div>
      </Popover>
    </div>
  );
};
